import React, { useState, useEffect } from "react";
import Navbar from "./Navbar";
import Shearchbar from "./Shearchbar";
import Swal from "sweetalert2";
import axios from "axios";
import secureLocalStorage from "react-secure-storage";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Link, useNavigate } from "react-router-dom";
import Manubar from "./Manubar";
import Footer from "./Footer";
import Security from "./Security";
import { FaEye, FaEyeSlash, FaArrowLeft, FaCopy, FaCheck } from "react-icons/fa";

const Signin = () => {
  let Navigate = useNavigate();

  // Form state
  const [step, setStep] = useState(1); // 1: Mobile, 2: PIN
  const [activeTab, setActiveTab] = useState("login"); // "login" or "register"

  // Mobile number input state
  const [mobileNumber, setMobileNumber] = useState("");
  const [numberError, setNumberError] = useState("");

  // PIN input states
  const [pinValue, setPinValue] = useState("");
  const [showPin, setShowPin] = useState(false);
  const [showRegisterPin, setShowRegisterPin] = useState(false);

  // Loading state
  const [isLoading, setIsLoading] = useState(false);
  const [isRegisterLoading, setIsRegisterLoading] = useState(false);

  // Terms checkbox
  const [acceptedTerms, setAcceptedTerms] = useState(false);

  // Forget PIN states
  const [showForgetEmailModal, setShowForgetEmailModal] = useState(false);
  const [showForgetOTPModal, setShowForgetOTPModal] = useState(false);
  const [forgetEmail, setForgetEmail] = useState("");
  const [forgetOtp, setForgetOtp] = useState("");
  const [newPin, setNewPin] = useState("");
  const [confirmNewPin, setConfirmNewPin] = useState("");
  const [userId, setUserId] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [pinError, setPinError] = useState("");
  const [isSendingOtp, setIsSendingOtp] = useState(false);
  const [isResettingPin, setIsResettingPin] = useState(false);
  const [showSendOtpButton, setShowSendOtpButton] = useState(false);

  // OTP DISPLAY
  const [receivedOtp, setReceivedOtp] = useState("");
  const [showOtpDisplay, setShowOtpDisplay] = useState(false);
  const [copied, setCopied] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [canResend, setCanResend] = useState(false);

  // Register states
  let [numbermsg, setnumbermsg] = useState();
  let [emailmsg, setemailmsg] = useState();
  let [inputval, setinputval] = useState({
    full_name: "",
    mobile_no: "",
    email: "",
    pin: "",
  });

  const primaryColor = "#ffa11d";
  const lightColor = "#fff8f5";

  // Countdown timer for OTP resend
  useEffect(() => {
    let timer;
    if (showOtpDisplay && countdown > 0) {
      timer = setTimeout(() => setCountdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [showOtpDisplay, countdown]);

  // Show Success Swal
  const showSuccessSwal = (userData, message) => {
    Swal.fire({
      html: `
      <div class="container-fluid p-0">
        <div class="d-flex flex-column align-items-center text-center">

          <!-- Animated Icon -->
          <div class="mb-3">
            <div 
              class="rounded-circle d-flex align-items-center justify-content-center shadow"
              style="
                width:80px;
                height:80px;
                background: linear-gradient(135deg, #28a745, #5dd879);
                animation: scaleIn 0.4s ease;
              "
            >
              <svg width="38" height="38" fill="white" viewBox="0 0 16 16">
                <path d="M13.485 1.929a.75.75 0 0 1 .086 1.056l-7.25 9a.75.75 0 0 1-1.08.04l-3.25-3.25a.75.75 0 1 1 1.06-1.06l2.67 2.67 6.72-8.35a.75.75 0 0 1 1.056-.086z"/>
              </svg>
            </div>
          </div>

          <!-- Title -->
          <h5 class="fw-bold mb-1">Login Successful</h5>

          <!-- Message -->
          <p class="text-muted small mb-3">
            ${message}
          </p>

          <!-- Status -->
          <span class="badge rounded-pill bg-success-subtle text-success px-3 py-2">
            Redirecting securely...
          </span>

          <!-- Progress -->
          <div class="progress mt-4 w-100" style="height:5px;">
            <div 
              class="progress-bar progress-bar-striped progress-bar-animated bg-success"
              style="width:100%"
            ></div>
          </div>

        </div>
      </div>

      <style>
        @keyframes scaleIn {
          from { transform: scale(0.7); opacity: 0 }
          to { transform: scale(1); opacity: 1 }
        }
      </style>
    `,
      showConfirmButton: false,
      width: 420,
      padding: '1.5rem',
      backdrop: 'rgba(0,0,0,0.45)',
      allowOutsideClick: false,
      allowEscapeKey: false,
      timer: 2600,
      willClose: () => Navigate("/")
    });
  };

  const showErrorSwal = (message) => {
    Swal.fire({
      html: `
        <div class="d-flex flex-column align-items-center text-center">

          <!-- Icon -->
          <div 
            class="rounded-circle d-flex align-items-center justify-content-center shadow mb-3"
            style="
              width:75px;
              height:75px;
              background: linear-gradient(135deg, #dc3545, #ff6b6b);
            "
          >
            <svg width="36" height="36" fill="white" viewBox="0 0 16 16">
              <path d="M8 1.5a6.5 6.5 0 1 1 0 13a6.5 6.5 0 0 1 0-13Zm0 3a.75.75 0 0 0-.75.75v3.5a.75.75 0 0 0 1.5 0v-3.5A.75.75 0 0 0 8 4.5Zm0 7a1 1 0 1 0 0-2a1 1 0 0 0 0 2Z"/>
            </svg>
          </div>

          <!-- Title -->
          <h6 class="fw-bold mb-1">Login Failed</h6>

          <!-- Message -->
          <p class="text-muted small mb-4">
            ${message}
          </p>

          <!-- Action -->
          <button 
            id="swalTryAgainBtn"
            class="btn btn-outline-danger px-4 rounded-pill fw-semibold"
          >
            Try Again
          </button>

        </div>
      `,
      showConfirmButton: false,
      width: 400,
      padding: '1.5rem',
      backdrop: 'rgba(0,0,0,0.45)',
      allowOutsideClick: true,
      allowEscapeKey: true,
      didOpen: () => {
        const btn = document.getElementById("swalTryAgainBtn");
        if (btn) {
          btn.addEventListener("click", () => {
            Swal.close();
          });
        }
      }
    });
  };

  // Handle mobile number submission - Go to PIN step
  const handleMobileSubmit = (e) => {
    e.preventDefault();

    // Validation
    if (!acceptedTerms) {
      toast.error("Please accept the terms & conditions");
      return;
    }

    if (!/^[0-9]{10}$/.test(mobileNumber)) {
      setNumberError("Please enter a valid 10-digit mobile number");
      return;
    }

    setNumberError("");
    setStep(2);
    setPinValue("");
  };

  // Handle PIN submission (login)
  const handlePinSubmit = (e) => {
    e.preventDefault();

    // Validate PIN
    if (!/^[0-9]{4}$/.test(pinValue)) {
      toast.error("PIN must be 4 digits");
      return;
    }

    setIsLoading(true);

    const loginData = {
      mobile_no: mobileNumber,
      pin: pinValue,
    };

    axios
      .post(`${process.env.REACT_APP_API}website/login`, loginData)
      .then((res) => {
        localStorage.setItem("localdata", JSON.stringify(res.data.data));
        if (res.data.result) {
            localStorage.setItem("ssstoken", res.data.data.token);
            secureLocalStorage.setItem("n_id", res.data.data._id);
            secureLocalStorage.setItem("n_token", res.data.data.token);
            secureLocalStorage.setItem("n_mobile_no", res.data.data.mobile_no);

          const user = res.data.data;        
          
          secureLocalStorage.setItem("n_full_name", user.full_name);
          secureLocalStorage.setItem("n_email", user.email);
          setPinValue("");
          setMobileNumber("");
          setStep(1);
          setAcceptedTerms(false);
          showSuccessSwal(user, res.data.msg || "Login successful!");

        } else {
          toast.error(res.data.msg || "Login failed");
        }
      })
      .catch((error) => {
        if (error.response?.data?.msg) {
          showErrorSwal(error.response.data.msg);
        } else {
          showErrorSwal("Something went wrong. Please try again.");
        }
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  // Forget PIN - Open Email Modal
  const handleForgotPinClick = () => {
    setShowForgetEmailModal(true);
    setForgetEmail("");
    setEmailError("");
    setShowSendOtpButton(false);
    // Reset OTP display states
    setShowOtpDisplay(false);
    setReceivedOtp("");
    setCountdown(30);
    setCanResend(false);
  };

  // Email validation - Check if valid email to show Send OTP button
  useEffect(() => {
    const validateEmail = () => {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/i;

      if (!forgetEmail.trim()) {
        setEmailError("");
        setShowSendOtpButton(false);
        return;
      }

      if (!emailRegex.test(forgetEmail.trim())) {
        setEmailError("Please enter a valid email address");
        setShowSendOtpButton(false);
      } else {
        setEmailError("");
        setShowSendOtpButton(true);
      }
    };

    // Debounce validation
    const timeoutId = setTimeout(validateEmail, 500);
    return () => clearTimeout(timeoutId);
  }, [forgetEmail]);

  // Copy OTP to clipboard
  const copyOtpToClipboard = () => {
    navigator.clipboard.writeText(receivedOtp).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  // Auto-fill OTP when received
  useEffect(() => {
    if (receivedOtp && showForgetOTPModal) {
      setForgetOtp(receivedOtp);
    }
  }, [receivedOtp, showForgetOTPModal]);

  // Forget PIN - Send OTP (Step 1)
  const handleSendOtp = async () => {
    if (!forgetEmail.trim()) {
      setEmailError("Please enter your email address");
      return;
    }

    setIsSendingOtp(true);
    setEmailError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/forget_pin`,
        {
          email: forgetEmail.trim(),
        }
      );

      if (response.data.result === "true") {
        // Store userId and OTP from response
        setUserId(response.data.data.userId);
        setReceivedOtp(response.data.data.otp);

        // Show success message
        toast.success("OTP sent successfully! Please check your email.");

        // Close email modal and open OTP modal
        setShowForgetEmailModal(false);

        // Reset countdown
        setCountdown(30);
        setCanResend(false);

        // Small delay for better UX
        setTimeout(() => {
          setShowForgetOTPModal(true);
          setShowOtpDisplay(true);
          setOtpError("");
          setPinError("");
          setNewPin("");
          setConfirmNewPin("");
        }, 300);

      } else {
        setEmailError(response.data.msg || "Failed to send OTP");
      }
    } catch (error) {
      console.error("Send OTP error:", error);
      setEmailError(
        error.response?.data?.msg ||
        "Failed to send OTP. Please check your email and try again."
      );
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Resend OTP
  const handleResendOtp = async () => {
    if (!canResend) return;

    setIsSendingOtp(true);
    setCanResend(false);
    setCountdown(30);

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/forget_pin`,
        {
          email: forgetEmail.trim(),
        }
      );

      if (response.data.result === "true") {
        // Update received OTP
        setReceivedOtp(response.data.data.otp);
        toast.success("New OTP sent successfully!");
      } else {
        toast.error(response.data.msg || "Failed to resend OTP");
      }
    } catch (error) {
      toast.error("Failed to resend OTP. Please try again.");
    } finally {
      setIsSendingOtp(false);
    }
  };

  // Verify OTP and Set New PIN (Step 2)
  const handleResetPin = async (e) => {
    e.preventDefault();

    // Validations
    if (!forgetOtp.trim()) {
      setOtpError("Please enter OTP");
      return;
    }

    if (forgetOtp.trim().length !== 4) {
      setOtpError("OTP must be 4 digits");
      return;
    }

    if (!newPin.trim()) {
      setPinError("Please enter new PIN");
      return;
    }

    if (newPin.trim().length !== 4) {
      setPinError("PIN must be 4 digits");
      return;
    }

    if (!confirmNewPin.trim()) {
      setPinError("Please confirm new PIN");
      return;
    }

    if (newPin.trim() !== confirmNewPin.trim()) {
      setPinError("PINs do not match");
      return;
    }

    setIsResettingPin(true);
    setOtpError("");
    setPinError("");

    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API}website/verify_otp`,
        {
          otp: forgetOtp.trim(),
          new_pin: newPin.trim(),
          _id: userId,
        }
      );

      if (
        response.data.result === "true" ||
        response.data.msg === "forgot success full" ||
        response.data.msg?.toLowerCase().includes("success")
      ) {
        // Show success message
        Swal.fire({
          title: 'Success!',
          text: 'Your PIN has been reset successfully!',
          icon: 'success',
          confirmButtonColor: primaryColor,
          confirmButtonText: 'Login Now'
        }).then(() => {
          // Close all modals
          setShowForgetOTPModal(false);
          setShowForgetEmailModal(false);

          // Reset all states
          resetForgotPasswordStates();

          // Clear PIN field in login form
          setPinValue("");

          // Focus on PIN field
          setTimeout(() => {
            const pinInput = document.querySelector('input[placeholder="Enter 4-digit PIN"]');
            if (pinInput) pinInput.focus();
          }, 100);
        });

      } else {
        setOtpError(response.data.msg || "Failed to reset PIN");
      }
    } catch (error) {
      console.error("Reset PIN error:", error);
      setOtpError(
        error.response?.data?.msg ||
        "Invalid OTP or failed to reset PIN. Please try again."
      );
    } finally {
      setIsResettingPin(false);
    }
  };

  // Reset all forgot password states
  const resetForgotPasswordStates = () => {
    setForgetEmail("");
    setForgetOtp("");
    setNewPin("");
    setConfirmNewPin("");
    setUserId("");
    setEmailError("");
    setOtpError("");
    setPinError("");
    setShowSendOtpButton(false);
    setIsSendingOtp(false);
    setIsResettingPin(false);
    setReceivedOtp("");
    setShowOtpDisplay(false);
    setCopied(false);
    setCountdown(30);
    setCanResend(false);
  };

  // Close all forgot password modals
  const closeAllForgotModals = () => {
    setShowForgetEmailModal(false);
    setShowForgetOTPModal(false);
    resetForgotPasswordStates();
  };

  // Go back to mobile number step
  const goBackToMobile = () => {
    setStep(1);
    setPinValue("");
    closeAllForgotModals();
  };

  // Handle mobile number change
  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 10) {
      setMobileNumber(value);
      if (value.length === 10) {
        setNumberError("");
      }
    }
  };

  // Handle PIN change
  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, "");
    if (value.length <= 4) {
      setPinValue(value);
    }
  };

  // Toggle between login and register tabs
  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "login") {
      setStep(1);
      setMobileNumber("");
      setPinValue("");
      setAcceptedTerms(false);
    } else {
      // Reset register form
      setinputval({
        full_name: "",
        mobile_no: "",
        email: "",
        pin: "",
      });
      setShowRegisterPin(false);
    }
  };

  // Signup form Handel
  let formHandel = (event) => {
    event.preventDefault();
    let mmobile = /^\d{10}$|^\d{3}[-\s]\d{3}[-\s]\d{4}$/;
    let eemail = /^[a-zA-Z0-9._%+-]+@gmail\.com$/i;
    
    // Validation
    if (!inputval.full_name.trim()) {
      toast.error("Please enter your full name");
      return;
    }
    
    if (!eemail.test(inputval.email)) {
      setemailmsg("Please enter a valid Gmail address");
      return;
    } else {
      setemailmsg("");
    }
    
    if (!mmobile.test(inputval.mobile_no)) {
      setnumbermsg("Please enter a valid 10-digit mobile number");
      return;
    } else {
      setnumbermsg("");
    }
    
    if (!inputval.pin || inputval.pin.length !== 4) {
      toast.error("PIN must be 4 digits");
      return;
    }

    setIsRegisterLoading(true);

    axios
      .post(`${process.env.REACT_APP_API}website/signup`, inputval)
      .then((res) => {
        if (res.data.result === "true" || res.data.result === true) {
          // Store user data
          secureLocalStorage.setItem("n_id", res.data.data._id);
          secureLocalStorage.setItem("n_token", res.data.data.token);
          secureLocalStorage.setItem("n_mobile_no", res.data.data.mobile_no);
          secureLocalStorage.setItem("n_full_name", res.data.data.full_name);
          secureLocalStorage.setItem("n_email", res.data.data.email);
          
          // Show success message
          Swal.fire({
            title: 'Registration Successful!',
            text: 'Your account has been created successfully.',
            icon: 'success',
            confirmButtonColor: primaryColor,
            confirmButtonText: 'Continue to Login'
          }).then(() => {
            // Switch to login tab
            setActiveTab("login");
            // Set mobile number from registration
            setMobileNumber(inputval.mobile_no);
            // Reset register form
            setinputval({
              full_name: "",
              mobile_no: "",
              email: "",
              pin: "",
            });
            // Show PIN step
            setStep(2);
          });
        } else {
          toast.error(res.data.msg || "Registration failed");
        }
      })
      .catch((error) => {
        if (error.response?.data?.msg) {
          toast.error(error.response.data.msg);
        } else {
          toast.error("Registration failed. Please try again.");
        }
      })
      .finally(() => {
        setIsRegisterLoading(false);
      });
  };

  //inputvalue
  let inputvalue = (event) => {
    setinputval({ ...inputval, [event.target.name]: event.target.value });
  };

  return (
    <div>
      <ToastContainer position="top-center" autoClose={3000} />
      <Shearchbar />
      <Navbar />
      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <nav className="breadcrumb-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/">Home</Link>
                </li>
                <li className="breadcrumb-item active" aria-current="page">
                  login &amp; register
                </li>
              </ol>
            </div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div
        className="min-vh-100 d-flex align-items-center"
        style={{ backgroundColor: lightColor }}>
        <section className="contact py-5 w-100">
          <div className="container">
            <div className="row g-4 justify-content-start align-items-start">
              {/* Left Side - Image Section */}
              <div className="col-lg-7 d-none d-lg-block bg-white">
                <div className="position-relative">
                  <div
                    style={{
                      width: "100%",
                      height: "644px",
                      borderRadius: "15px",
                    }}
                    className="contact-image overflow-hidden rounded-4 shadow-lg">
                    <img
                      src="assets/images/logo/Vaishnavi2.png"
                      alt="Login"
                      style={{
                        width: "72%",
                        height: "29%",
                        position: "absolute",
                        top: "250px",
                        left: "100px",
                      }}
                    />
                  </div>
                  <div
                    className="position-absolute top-0 start-0"
                    style={{ zIndex: 2 }}>
                    <img
                      src="assets/images/login2.png"
                      alt="Decoration"
                      className="img-fluid"
                      style={{ maxWidth: "200px" }}
                    />
                  </div>
                  <div className="position-absolute top-0 end-0 mt-4 me-4">
                    <div className="bg-white p-3 rounded-3 shadow-sm">
                      <h5
                        className="fw-bold mb-2"
                        style={{ color: primaryColor }}>
                        {activeTab === "login" 
                          ? (step === 1 ? "Quick Sign In" : "Enter PIN") 
                          : "Create Account"}
                      </h5>
                      <p className="text-muted small mb-0">
                        {activeTab === "login" 
                          ? (step === 1 
                              ? "Enter mobile number to continue" 
                              : `Enter PIN for ${mobileNumber}`)
                          : "Fill in your details to create an account"}
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Right Side - Form Section */}
              <div className="col-lg-5 ms-auto">
                <div className="bg-white rounded-4 shadow-lg p-4 p-md-5">
                  {/* Header with Tabs */}
                  <div className="text-center mb-4">
                    <div className="mb-3"></div>
                    <div className="login-register-tab-list nav nav-tabs justify-content-center" role="tablist">
                      <button
                        className={`nav-link ${activeTab === "login" ? "active" : ""}`}
                        onClick={() => handleTabClick("login")}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "10px 20px",
                          fontSize: "18px",
                          fontWeight: activeTab === "login" ? "bold" : "normal",
                          color: activeTab === "login" ? primaryColor : "#666",
                          borderBottom: activeTab === "login" ? `2px solid ${primaryColor}` : "none"
                        }}
                      >
                        <h4 className="mb-0">Login</h4>
                      </button>
                      <button
                        className={`nav-link ${activeTab === "register" ? "active" : ""}`}
                        onClick={() => handleTabClick("register")}
                        style={{
                          border: "none",
                          background: "none",
                          padding: "10px 20px",
                          fontSize: "18px",
                          fontWeight: activeTab === "register" ? "bold" : "normal",
                          color: activeTab === "register" ? primaryColor : "#666",
                          borderBottom: activeTab === "register" ? `2px solid ${primaryColor}` : "none"
                        }}
                      >
                        <h4 className="mb-0">Register</h4>
                      </button>
                    </div>
                    <h3 className="fw-bold mb-2 mt-3" style={{ color: primaryColor }}>
                      {activeTab === "login" 
                        ? (step === 1 ? "Welcome Back!" : "Enter Your PIN")
                        : "Create New Account"}
                    </h3>
                    <p className="text-muted mb-0">
                      {activeTab === "login" 
                        ? (step === 1 
                            ? "Sign in with your mobile number & PIN"
                            : `Enter 4-digit PIN for ${mobileNumber}`)
                        : "Fill in your details to get started"}
                    </p>
                  </div>

                  {/* Login Form */}
                  {activeTab === "login" && (
                    <>
                      {/* STEP 1: Mobile Number Form */}
                      {step === 1 && (
                        <form onSubmit={handleMobileSubmit}>
                          <div className="mb-4">
                            <label className="form-label fw-semibold mb-2">
                              Mobile Number <span className="text-danger">*</span>
                            </label>
                            <div className="input-group">
                              <span className="input-group-text bg-light border-end-0">
                                <i className="bi bi-phone text-muted"></i>
                              </span>
                              <input
                                type="tel"
                                className="form-control border-start-0"
                                placeholder="Enter 10-digit number"
                                value={mobileNumber}
                                onChange={handleMobileChange}
                                maxLength="10"
                                style={{ paddingLeft: "0" }}
                              />
                            </div>
                            {numberError && (
                              <div className="text-danger small mt-1">{numberError}</div>
                            )}
                            <div className="form-text">
                              We'll ask for PIN after mobile verification
                            </div>
                          </div>

                          {/* Terms & Conditions */}
                          <div className="mb-4">
                            <div className="form-check">
                              <input
                                className="form-check-input"
                                type="checkbox"
                                id="termsCheck"
                                checked={acceptedTerms}
                                onChange={(e) => setAcceptedTerms(e.target.checked)}
                                style={{ borderColor: primaryColor }}
                              />
                              <label
                                className="form-check-label small"
                                htmlFor="termsCheck">
                                <Link
                                  to="/terms-conditions"
                                  className="text-decoration-none fw-semibold"
                                  style={{ color: primaryColor }}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  Terms & Conditions
                                </Link>{" "}
                                and{" "}
                                <Link
                                  to="/privacy-policy"
                                  className="text-decoration-none fw-semibold"
                                  style={{ color: primaryColor }}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  Privacy Policy
                                </Link>
                              </label>
                            </div>
                          </div>

                          {/* Continue Button */}
                          <button
                            type="submit"
                            className="btn w-100 py-3 fw-semibold border-0 mb-3"
                            disabled={isLoading || mobileNumber.length !== 10 || !acceptedTerms}
                            style={{
                              backgroundColor: primaryColor,
                              color: "white",
                              fontSize: "16px",
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              opacity: (isLoading || mobileNumber.length !== 10 || !acceptedTerms) ? 0.7 : 1,
                            }}
                            onMouseEnter={(e) => !isLoading && (e.target.style.opacity = "0.9")}
                            onMouseLeave={(e) => !isLoading && (e.target.style.opacity = "1")}>
                            {isLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Processing...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-arrow-right me-2"></i>
                                Continue to PIN
                              </>
                            )}
                          </button>

                          {/* Divider */}
                          <div className="position-relative my-4">
                            <hr className="my-4" />
                            <div className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">
                              OR
                            </div>
                          </div>

                          {/* Register Link */}
                          <div className="text-center pt-3">
                            <p className="mb-0 text-muted">
                              Don't have an account?{" "}
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none fw-bold"
                                onClick={() => handleTabClick("register")}
                                style={{ color: primaryColor }}>
                                Register Now
                              </button>
                            </p>
                          </div>
                        </form>
                      )}

                      {/* STEP 2: PIN Input Form */}
                      {step === 2 && (
                        <form onSubmit={handlePinSubmit}>
                          {/* Mobile number display */}
                          <div className="mb-3 p-3 border rounded bg-light">
                            <div className="d-flex justify-content-between align-items-center">
                              <div>
                                <small className="text-muted d-block">Mobile Number</small>
                                <strong>{mobileNumber}</strong>
                              </div>
                              <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={goBackToMobile}
                                disabled={isLoading}>
                                <FaArrowLeft className="me-1" />
                                Change
                              </button>
                            </div>
                          </div>

                          {/* PIN Input */}
                          <div className="mb-4">
                            <label className="form-label fw-semibold mb-2">
                              PIN <span className="text-danger">*</span>
                            </label>
                            <div className="position-relative">
                              <input
                                type={showPin ? "text" : "password"}
                                className="form-control py-3"
                                placeholder="Enter 4-digit PIN"
                                value={pinValue}
                                onChange={handlePinChange}
                                maxLength="4"
                                disabled={isLoading}
                                autoFocus
                              />
                              <span
                                onClick={() => !isLoading && setShowPin(!showPin)}
                                style={{
                                  position: "absolute",
                                  right: "15px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  cursor: isLoading ? "not-allowed" : "pointer",
                                  color: isLoading ? "#ccc" : "#555",
                                  pointerEvents: isLoading ? "none" : "auto",
                                }}>
                                {showPin ? <FaEyeSlash /> : <FaEye />}
                              </span>
                            </div>
                            <div className="form-text">Enter the 4-digit PIN you created during registration</div>
                          </div>

                          {/* Forgot PIN link */}
                          <div className="text-end mb-4">
                            <button
                              type="button"
                              className="btn btn-link p-0 text-decoration-none"
                              onClick={handleForgotPinClick}
                              style={{ color: primaryColor, fontSize: "14px" }}
                              disabled={isLoading}>
                              Forgot PIN?
                            </button>
                          </div>

                          {/* Login Button */}
                          <button
                            type="submit"
                            className="btn w-100 py-3 fw-semibold border-0 mb-3"
                            disabled={isLoading || pinValue.length !== 4}
                            style={{
                              backgroundColor: primaryColor,
                              color: "white",
                              fontSize: "16px",
                              borderRadius: "8px",
                              transition: "all 0.3s",
                              opacity: (isLoading || pinValue.length !== 4) ? 0.7 : 1,
                            }}>
                            {isLoading ? (
                              <>
                                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                                Logging in...
                              </>
                            ) : (
                              <>
                                <i className="bi bi-box-arrow-in-right me-2"></i>
                                Login
                              </>
                            )}
                          </button>

                          {/* Back to mobile link */}
                          <div className="text-center">
                            <button
                              type="button"
                              className="btn btn-link text-decoration-none"
                              onClick={goBackToMobile}
                              style={{ color: primaryColor, fontSize: "14px" }}
                              disabled={isLoading}>
                              <i className="bi bi-arrow-left me-1"></i>
                              Use different mobile number
                            </button>
                          </div>

                          {/* Register Link */}
                          <div className="text-center pt-3 border-top mt-4">
                            <p className="mb-0 text-muted">
                              Don't have an account?{" "}
                              <button
                                type="button"
                                className="btn btn-link p-0 text-decoration-none fw-bold"
                                onClick={() => handleTabClick("register")}
                                style={{ color: primaryColor }}>
                                Register Now
                              </button>
                            </p>
                          </div>
                        </form>
                      )}
                    </>
                  )}

                  {/* Register Form */}
                  {activeTab === "register" && (
                    <form onSubmit={formHandel}>
                      {/* Full Name */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Full Name <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0">
                            <i className="bi bi-person text-muted"></i>
                          </span>
                          <input
                            required
                            type="text"
                            name="full_name"
                            value={inputval.full_name}
                            onChange={inputvalue}
                            placeholder="Enter your full name"
                            className="form-control border-start-0"
                            style={{ paddingLeft: "0" }}
                          />
                        </div>
                      </div>

                      {/* Email */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Email <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0">
                            <i className="bi bi-envelope text-muted"></i>
                          </span>
                          <input
                            required
                            name="email"
                            value={inputval.email}
                            onChange={inputvalue}
                            placeholder="Enter your email"
                            type="email"
                            className="form-control border-start-0"
                            style={{ paddingLeft: "0" }}
                          />
                        </div>
                        {emailmsg && (
                          <div className="text-danger small mt-1">{emailmsg}</div>
                        )}
                        <div className="form-text">We'll send important updates to this email</div>
                      </div>

                      {/* Mobile Number */}
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Mobile Number <span className="text-danger">*</span>
                        </label>
                        <div className="input-group">
                          <span className="input-group-text bg-light border-end-0">
                            <i className="bi bi-phone text-muted"></i>
                          </span>
                          <input
                            required
                            name="mobile_no"
                            value={inputval.mobile_no}
                            maxLength={10}
                            onChange={inputvalue}
                            placeholder="Enter 10-digit mobile number"
                            type="tel"
                            className="form-control border-start-0"
                            style={{ paddingLeft: "0" }}
                          />
                        </div>
                        {numbermsg && (
                          <div className="text-danger small mt-1">{numbermsg}</div>
                        )}
                        <div className="form-text">This will be your login mobile number</div>
                      </div>

                      {/* PIN */}
                      <div className="mb-4">
                        <label className="form-label fw-semibold">
                          4-Digit PIN <span className="text-danger">*</span>
                        </label>
                        <div className="position-relative">
                          <div className="input-group">
                            <span className="input-group-text bg-light border-end-0">
                              <i className="bi bi-lock text-muted"></i>
                            </span>
                            <input
                              type={showRegisterPin ? "text" : "password"}
                              name="pin"
                              placeholder="Enter 4-digit PIN"
                              maxLength="4"
                              value={inputval.pin}
                              onChange={(e) => {
                                const val = e.target.value.replace(/\D/g, "");
                                if (val.length <= 4) {
                                  setinputval({ ...inputval, pin: val });
                                }
                              }}
                              required
                              className="form-control border-start-0"
                              style={{ paddingLeft: "0" }}
                            />
                            <span
                              className="input-group-text bg-light border-start-0"
                              onClick={() => setShowRegisterPin(!showRegisterPin)}
                              style={{ cursor: "pointer" }}>
                              {showRegisterPin ? <FaEyeSlash /> : <FaEye />}
                            </span>
                          </div>
                        </div>
                        <div className="form-text">Create a 4-digit PIN for secure login</div>
                      </div>

                      {/* Terms & Conditions for Register */}
                      <div className="mb-4">
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="checkbox"
                            id="registerTermsCheck"
                            required
                            style={{ borderColor: primaryColor }}
                          />
                         <label
                                className="form-check-label small"
                                htmlFor="termsCheck">
                                <Link
                                  to="/terms-conditions"
                                  className="text-decoration-none fw-semibold"
                                  style={{ color: primaryColor }}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  Terms & Conditions
                                </Link>{" "}
                                and{" "}
                                <Link
                                  to="/privacy-policy"
                                  className="text-decoration-none fw-semibold"
                                  style={{ color: primaryColor }}
                                  target="_blank"
                                  rel="noopener noreferrer">
                                  Privacy Policy
                                </Link>
                              </label>
                        </div>
                      </div>

                      {/* Register Button */}
                      <button
                        type="submit"
                        className="btn w-100 py-3 fw-semibold border-0 mb-3"
                        disabled={isRegisterLoading}
                        style={{
                          backgroundColor: primaryColor,
                          color: "white",
                          fontSize: "16px",
                          borderRadius: "8px",
                          transition: "all 0.3s",
                          opacity: isRegisterLoading ? 0.7 : 1,
                        }}>
                        {isRegisterLoading ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                            Creating Account...
                          </>
                        ) : (
                          <>
                            <i className="bi bi-person-plus me-2"></i>
                            Create Account
                          </>
                        )}
                      </button>

                      {/* Divider */}
                      <div className="position-relative my-4">
                        <hr className="my-4" />
                        <div className="position-absolute top-50 start-50 translate-middle bg-white px-3 text-muted small">
                          OR
                        </div>
                      </div>

                      {/* Login Link */}
                      <div className="text-center pt-3">
                        <p className="mb-0 text-muted">
                          Already have an account?{" "}
                          <button
                            type="button"
                            className="btn btn-link p-0 text-decoration-none fw-bold"
                            onClick={() => handleTabClick("login")}
                            style={{ color: primaryColor }}>
                            Login Now
                          </button>
                        </p>
                      </div>
                    </form>
                  )}
                </div>
              </div>

              <div className="col-12 d-block d-lg-none">
                <div className="text-center mb-4">
                  <div className="rounded-3 overflow-hidden shadow">
                    <img
                      src="assets/images/login1.jpg"
                      alt="Login"
                      className="w-100"
                      style={{ maxHeight: "200px", objectFit: "cover" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Forget Email Modal */}
      {showForgetEmailModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold" style={{ color: primaryColor }}>
                  Reset Your PIN
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeAllForgotModals}
                  disabled={isSendingOtp}
                />
              </div>
              <div className="modal-body pt-0">
                <p className="text-muted mb-3">
                  Enter your registered email address. We'll send an OTP to reset your PIN.
                </p>

                <div className="mb-3">
                  <label className="form-label fw-semibold">Email Address</label>
                  <input
                    type="email"
                    className="form-control"
                    placeholder="Enter your email"
                    value={forgetEmail}
                    onChange={(e) => setForgetEmail(e.target.value)}
                    disabled={isSendingOtp}
                    autoFocus
                  />
                  {emailError && (
                    <div className="text-danger small mt-1">{emailError}</div>
                  )}
                </div>

                {showSendOtpButton && (
                  <div className="d-grid mt-4">
                    <button
                      type="button"
                      className="btn py-2 fw-semibold"
                      onClick={handleSendOtp}
                      disabled={isSendingOtp}
                      style={{
                        backgroundColor: primaryColor,
                        color: "white",
                      }}>
                      {isSendingOtp ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Sending OTP...
                        </>
                      ) : (
                        'Send OTP'
                      )}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Forget OTP Modal */}
      {showForgetOTPModal && (
        <div className="modal show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header border-bottom-0 pb-0">
                <h5 className="modal-title fw-bold" style={{ color: primaryColor }}>
                  Verify OTP & Set New PIN
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={closeAllForgotModals}
                  disabled={isResettingPin}
                />
              </div>
              <div className="modal-body pt-0">
                <p className="text-muted mb-3">
                  Enter the 4-digit OTP sent to <strong>{forgetEmail}</strong> and set your new PIN.
                </p>

                {/* OTP Display Box */}
                {showOtpDisplay && receivedOtp && (
                  <div className="mb-4 p-3 border rounded bg-light">
                    <div className="d-flex justify-content-between align-items-center">
                      <div>
                        <small className="text-muted d-block">Your OTP</small>
                        <div className="d-flex align-items-center">
                          <h4 className="fw-bold mb-0 me-3" style={{ color: primaryColor }}>
                            {receivedOtp}
                          </h4>
                          <button
                            type="button"
                            className="btn btn-sm btn-outline-secondary"
                            onClick={copyOtpToClipboard}
                            title="Copy OTP"
                          >
                            {copied ? <FaCheck className="text-success" /> : <FaCopy />}
                          </button>
                        </div>
                        <small className="text-muted">
                          {copied ? "Copied to clipboard!" : "Click copy icon to copy"}
                        </small>
                      </div>
                      <div className="text-end">
                        <small className="text-muted d-block">Valid for</small>
                        <span className={`badge ${countdown > 10 ? 'bg-success' : 'bg-warning'}`}>
                          {countdown}s
                        </span>
                      </div>
                    </div>
                  </div>
                )}

                <form onSubmit={handleResetPin}>
                  {/* OTP Input */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">Enter OTP</label>
                    <input
                      type="text"
                      className="form-control text-center"
                      placeholder="0000"
                      value={forgetOtp}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 4) setForgetOtp(val);
                      }}
                      maxLength="4"
                      disabled={isResettingPin}
                      style={{ letterSpacing: '10px', fontSize: '1.2rem' }}
                      autoFocus
                    />
                    {otpError && (
                      <div className="text-danger small mt-1">{otpError}</div>
                    )}
                  </div>

                  {/* New PIN Input */}
                  <div className="mb-3">
                    <label className="form-label fw-semibold">New 4-Digit PIN</label>
                    <input
                      type="password"
                      className="form-control text-center"
                      placeholder="••••"
                      value={newPin}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 4) setNewPin(val);
                      }}
                      maxLength="4"
                      disabled={isResettingPin}
                      style={{ letterSpacing: '5px', fontSize: '1.2rem' }}
                    />
                  </div>

                  {/* Confirm New PIN */}
                  <div className="mb-4">
                    <label className="form-label fw-semibold">Confirm New PIN</label>
                    <input
                      type="password"
                      className="form-control text-center"
                      placeholder="••••"
                      value={confirmNewPin}
                      onChange={(e) => {
                        const val = e.target.value.replace(/\D/g, "");
                        if (val.length <= 4) setConfirmNewPin(val);
                      }}
                      maxLength="4"
                      disabled={isResettingPin}
                      style={{ letterSpacing: '5px', fontSize: '1.2rem' }}
                    />
                    {pinError && (
                      <div className="text-danger small mt-1">{pinError}</div>
                    )}
                  </div>

                  {/* Submit Button */}
                  <div className="d-grid">
                    <button
                      type="submit"
                      className="btn py-2 fw-semibold"
                      disabled={isResettingPin || !forgetOtp || !newPin || !confirmNewPin}
                      style={{
                        backgroundColor: primaryColor,
                        color: "white",
                        opacity: (isResettingPin || !forgetOtp || !newPin || !confirmNewPin) ? 0.7 : 1,
                      }}>
                      {isResettingPin ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                          Resetting PIN...
                        </>
                      ) : (
                        'Reset PIN'
                      )}
                    </button>
                  </div>
                </form>

                {/* Resend OTP Link */}
                <div className="text-center mt-3">
                  <button
                    type="button"
                    className="btn btn-link text-decoration-none p-0"
                    onClick={handleResendOtp}
                    disabled={isSendingOtp || isResettingPin || !canResend}
                    style={{
                      color: canResend ? primaryColor : '#999',
                      fontSize: '14px',
                      cursor: canResend ? 'pointer' : 'not-allowed'
                    }}>
                    {isSendingOtp ? (
                      'Resending...'
                    ) : canResend ? (
                      'Resend OTP'
                    ) : (
                      `Resend OTP in ${countdown}s`
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      <Security />
      <Footer />
    </div>
  );
};

export default Signin;

